import { useEffect } from 'react';
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TableHead
} from '@mui/material';
import { connect } from 'react-redux';
import { formatRelative } from 'date-fns';
import dateLocaleConfig from 'date-fns/locale/es';
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import { Loading } from '../components/Loading';
import { fLogType } from '../utils/formatEnums';

const Logs = ({ category, fetchLogsByPropertyId, logs, isLoadingLogs, selectedProperty }) => {
  useEffect(() => {
    if (selectedProperty) {
      fetchLogsByPropertyId({ propertyId: selectedProperty.id, category });
    }
  }, [selectedProperty, category]);

  if (isLoadingLogs) {
    return <Loading />;
  }

  return (
    <Page title="Registro histórico | Chapapp">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Registro histórico
          </Typography>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="normal" align="left">
                      Tipo
                    </TableCell>
                    <TableCell align="left">Chapa</TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Descripción</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {logs &&
                    logs.map((row) => {
                      const { type, chapaName, createdAt, description } = row;
                      // const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow hover key={createdAt} tabIndex={-1} role="checkbox">
                          <TableCell align="left">
                            <Label variant="ghost">{fLogType(type)}</Label>
                          </TableCell>
                          <TableCell align="left">{chapaName}</TableCell>
                          <TableCell align="left">
                            {createdAt &&
                              formatRelative(new Date(createdAt), new Date(), {
                                locale: dateLocaleConfig
                              })}
                          </TableCell>
                          <TableCell align="left">{description}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* <TablePagination */}
          {/*  rowsPerPageOptions={[5, 10, 25]} */}
          {/*  component="div" */}
          {/*  count={USERLIST.length} */}
          {/*  rowsPerPage={rowsPerPage} */}
          {/*  page={page} */}
          {/*  onPageChange={handleChangePage} */}
          {/*  onRowsPerPageChange={handleChangeRowsPerPage} */}
          {/* /> */}
        </Card>
      </Container>
    </Page>
  );
};

const mapState = (state) => ({
  logs: state.logs.list,
  isLoadingLogs: state.loading.effects.logs.fetchByPropertyId.loading,
  selectedProperty: state.property.selectedProperty
});

const mapDispatch = (dispatch) => ({
  fetchLogsByPropertyId: dispatch.logs.fetchByPropertyId
});

export default connect(mapState, mapDispatch)(Logs);
